import { Action, Dispatch } from "redux";
import { FGetState } from "../app.reducer";

export type FuncAction = (
  dispatch: Dispatch,
  getState: FGetState
) => Promise<void>;
export type FuncSyncAction = (dispatch: Dispatch, getState: FGetState) => void;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  LOADING: {
    SHOW: "SHOW_LOADING",
    HIDE: "HIDE_LOADING"
  },
};

export class LoginDto {
  username!: string;
  password!: string;
}

export interface CommonState {
  isLoading: boolean;
}
export interface ICommonAction extends Action {
  payload: any
}
